
import { checkFpiPdfExists, SupportedLanguage } from './pdf/languageUtils';
import { fetchSurveyQuestions } from './pdf/surveyDataFetcher';
import { generateSurveyQuestionsPDF } from './pdf/surveyPdfRenderer';
import { mergePDFs, downloadPDF } from './pdf/pdfMerger';

// Re-export for backwards compatibility
export { checkFpiPdfExists } from './pdf/languageUtils';

/**
 * Main function to generate and download a survey PDF
 * @param language - Language code
 * @param selectedSurvey - Survey number (1, 2, or 3)
 * @returns Promise resolving to true if successful
 */
export const generateSurveyPDF = async (language: string, selectedSurvey: string): Promise<boolean> => {
  try {
    // Verify FPI PDF exists
    const fpiPdfExists = await checkFpiPdfExists(language);
    if (!fpiPdfExists) {
      throw new Error(`No FPI PDF found for language: ${language}`);
    }

    // Fetch survey data
    const surveys = await fetchSurveyQuestions(language as SupportedLanguage, selectedSurvey);
    
    // Generate survey questions PDF
    const surveyPdfBytes = await generateSurveyQuestionsPDF(
      language as SupportedLanguage, 
      selectedSurvey,
      surveys
    );

    // Merge PDFs and download
    const mergedPdf = await mergePDFs(language, surveyPdfBytes);
    downloadPDF(mergedPdf, language, selectedSurvey);

    return true;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
